import React, { useState } from 'react';
import { useHistory } from "react-router";
import { Container, Title, Paragraph, Link, ButtonContainer } from './DeleteAccount.styles';
import { Button } from '@material-ui/core';
import DeleteModal from '../../../components/DeleteModal/DeleteModal';
import FixedLoader from "../../../components/FixedLoader/FixedLoader";
import FixedError from "../../../components/FixedError/FixedError";
import useActionApi from "../../../hooks/useActionApi";
import Api from "../../../api";
import { TopBarRedesigned } from "components/TopBarRedesigned";
import { exitReact } from 'utils';


const TempStars = (window as any).TempStars;

const DentistDeleteAccount: React.FC = () => {
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);

    const confirmDelete = () => {
        TempStars.User.logout();
        history.push('landing');
    };

    const [deleteUserLoading, deleteUserError, deleteUserAccount] = useActionApi({
        apiMethod: Api.deleteUser,
        onSuccess: (response) => {
            confirmDelete();
        },
    });

  const handleOpen = () => {
    setIsOpen(!isOpen);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleDeleteConfirm = () => {
    deleteUserAccount({});
  };


  const { userEmail } = history.location.state as { userEmail: string };

  return (
    <Container>
      <TopBarRedesigned
              title={'Delete your account?'}
              onBack={() => {
                history.push({ pathname: 'dentistHome' })
              }}
            />
      <Paragraph>
        Aw shucks - honestly <strong>{userEmail}</strong>, we really hate to see you go!
      </Paragraph>
      <Paragraph>
        Of course we're happy to honor your request. Just a quick note if you decide to delete your account:
      </Paragraph>
      <Paragraph>
        When you click "Submit Deletion Request", this prevents anyone from accessing your personal information, including TempStars employees, leadership or even our engineering team. <Link className="link external" href="https://www.tempstars.com/privacy" target="_blank">Review our Privacy Policy here.</Link>
      </Paragraph>
      <Paragraph>
        <strong>But also keep in mind - you will not be able to access your TempStars account at all - this means past invoices and records.</strong>
      </Paragraph>
      <Paragraph>
        That being said, we do keep a securely encrypted version of some of your account details on record. This allows our system to automatically detect duplicate accounts to maintain the integrity of our system, database, and membership - while still maintaining the privacy of your information.
           </Paragraph>
      <Paragraph>
        This encryption maintains your privacy, but will prevent you from creating a new account with the same credentials. Our system automatically reviews all new accounts to prevent duplication, so deleting your account may affect your ability to create future accounts.
      </Paragraph>
      <Paragraph>
        This also has a benefit: If you end up changing your mind down the road, just let us know and we'll be happy to re-activate your account. This will trigger a secure process to de-encrypt your data and you can pick up where you left off!
      </Paragraph>
      <ButtonContainer>
        <Button  
          onClick={handleOpen}
          variant="contained"
          color="primary"
          size="medium"
          className="bigButtonInNewStyle mb-3">
            Submit Deletion Request
        </Button>
      </ButtonContainer>
      <DeleteModal isOpen={isOpen} onClose={handleClose} onConfirm={handleDeleteConfirm} loading={deleteUserLoading} />
        <FixedLoader loading={deleteUserLoading} />
        <FixedError error={deleteUserError} />
    </Container>
  );
};

export default DentistDeleteAccount;
